import React from 'react'
import classNames from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
import { Scrollbars } from "react-custom-scrollbars"
import './style.scss'

const DropdownContainer = ({ actions = [], list = [], listClick, showDropdown, setShowDropdown, position = 'right', emptyMessage, dropUp, autoHeightMax = 214, hasBadges, color = 'accent0', disabled }) => {

  const onOutsideClick = () => {
    setShowDropdown(false)
  }

  const onActionClick = (e, action) => {
    e.preventDefault()
    e.stopPropagation()
    setShowDropdown(false)
    action.onClick && action.onClick()
    listClick && listClick(action)
  }

  const actionClass = classNames(
    'viso-dropdown-container__panel',
    showDropdown && 'viso-dropdown-container__panel--visible',
    `viso-dropdown-container__panel--${position}`,
    dropUp && 'viso-dropdown-container__panel--drop-up'
  )

  return (
    <div className='viso-dropdown-container'>
      <OutsideClickHandler onOutsideClick={onOutsideClick}>
        <div className={actionClass}>
          <Scrollbars
            autoHeight
            autoHide
            autoHideDuration={1}
            className='custom-scrollbars'
            autoHeightMax={autoHeightMax}
            universal
            renderThumbVertical={(props) => (
              <div {...props} className='thumb-vertical' />
            )}
          >
            {actions.length > 0 && actions.map((action, index) =>
              action.isDivider ?
                <hr className='viso-dropdown-container__divider' key={index} />
                :
                (
                  <button
                    key={action.label}
                    className={classNames(
                      'viso-dropdown-container__option',
                      action.icon && 'viso-dropdown-container__option--icon',
                      hasBadges && 'viso-dropdown-container__option--has-badge',
                    )}
                    onClick={(e) => onActionClick(e, action)}
                    disabled={disabled?.value === action.value}
                  >
                    {action.icon}
                    {action.label}
                    {hasBadges && action.badge && <span className={`viso-dropdown-container__badge viso-dropdown-container__badge--${color}`}>{action.badge}</span>}
                  </button>
                )
            )}
            {list.length > 0 && list.map(item => (
              <button
                key={item}
                className='viso-dropdown-container__option'
                onClick={(e) => onActionClick(e, item)}
              >
                {item}
              </button>
            ))}
            {emptyMessage && list.length === 0 &&
              <div className='viso-dropdown-container__empty'>{emptyMessage}</div>
            }
          </Scrollbars>
        </div>
      </OutsideClickHandler>
    </div>
  )
}

export default DropdownContainer